import React, { Component } from 'react';
import {
  BrowserRouter, Route, Switch,
} from 'react-router-dom';
import ScrollToTop from 'react-router-scroll-top';
import './styles/global';
import api from './services/api';

import Base from './components/Base';
import Auth from './components/Auth';
import BaseAdmin from './admin/components/Base';
import AuthAdmin from './admin/components/Auth';
import Home from './pages/Home';
import NotFound from './pages/NotFound';
import PrivacyPolicy from './pages/PrivacyPolicy';

export default class App extends Component {
  state = {
    path: window.location.pathname,
  };

  componentDidMount() {
    const { path } = this.state;
    if (path.startsWith('/privacy')) {
      return;
    }
    if (path.startsWith('/admin') && localStorage.getItem('token_admin')) {
      this.checkTokenAdmin();
    } else if (path.startsWith('/panel') && localStorage.getItem('token_producer')) {
      this.checkTokenProducer();
    }
  }

  checkTokenAdmin = async () => {
    const path = window.location.pathname;
    try {
      await api.get('admins/current', {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token_admin')}`,
        },
      });
    } catch (err) {
      window.localStorage.removeItem('token_admin');
      if (path !== '/admin') {
        window.location.href = '/admin';
      }
    }
  };

  checkTokenProducer = async () => {
    const path = window.location.pathname;
    try {
      await api.get('producers/current', {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token_producer')}`,
        },
      });
    } catch (err) {
      window.localStorage.removeItem('token_producer');
      if (!path.startsWith('/auth')) {
        window.location.href = '/auth';
      }
    }
  };

  render() {
    return (
      <BrowserRouter>
        <ScrollToTop>
          <Switch>
            <Route exact path="/" component={Home} />
            <Route exact path="/privacy" component={PrivacyPolicy} />
            <Route path="/auth" component={Auth} />
            <Route path="/panel" component={Base} />
            <Route exact path="/admin" component={AuthAdmin} />
            <Route path="/admin/dashboard" component={BaseAdmin} />
            <Route component={NotFound} />
          </Switch>
        </ScrollToTop>
      </BrowserRouter>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App.js